import type { MockCache } from '../types';

import { rebuildIndex } from './indexes';

export let activeCache: MockCache | null = null;
export const ANY_CHANGE_KEY = '*';
const keyVersions = new Map<string, number>();
const keyListeners = new Map<string, Set<() => void>>();
let nextActivitySeq = 1;
let nextInboxSeq = 1;

export function setActiveCache(cache: MockCache): void {
  activeCache = cache;
}

export function takeActivitySeq(): number {
  const seq = nextActivitySeq;
  nextActivitySeq += 1;
  return seq;
}

export function takeInboxSeq(): number {
  const seq = nextInboxSeq;
  nextInboxSeq += 1;
  return seq;
}

export function raiseSeqCounters(activitySeq: number, inboxSeq: number): { activity: number; inbox: number } {
  nextActivitySeq = Math.max(nextActivitySeq, activitySeq);
  nextInboxSeq = Math.max(nextInboxSeq, inboxSeq);
  return { activity: nextActivitySeq, inbox: nextInboxSeq };
}

export function getVersion(key: string): number {
  return keyVersions.get(key) ?? 0;
}

export function bump(...keys: string[]): void {
  for (const key of [...keys, ANY_CHANGE_KEY]) {
    keyVersions.set(key, getVersion(key) + 1);
    const listeners = keyListeners.get(key);
    if (listeners !== undefined) {
      for (const notify of Array.from(listeners)) {
        notify();
      }
    }
  }
}

export function subscribeKeys(keys: string[], notify: () => void): () => void {
  for (const key of keys) {
    let listeners = keyListeners.get(key);
    if (listeners === undefined) {
      listeners = new Set();
      keyListeners.set(key, listeners);
    }
    listeners.add(notify);
  }
  return () => {
    for (const key of keys) {
      keyListeners.get(key)?.delete(notify);
    }
  };
}

export function requireCache(): MockCache {
  const cache = activeCache;
  if (cache === null) {
    throw new Error('Мок-стор не инициализирован: оберните дерево в <MockStoreProvider cache={...} />');
  }
  return cache;
}

export function getActiveCache(): MockCache | null {
  return activeCache;
}

export function createCache(seed: MockCache): MockCache {
  rebuildIndex(seed);
  nextActivitySeq = seed.activity.reduce((max, event) => Math.max(max, event.seq + 1), 1);
  nextInboxSeq = Array.from(seed.inbox.values()).reduce((max, item) => Math.max(max, item.seq + 1), 1);
  activeCache = seed;
  return seed;
}
